import React, { FC, ReactNode, useState } from 'react';
import _                                  from 'underscore';

/* Value that could be a string, ReactNode, or a function. When using a function,
arguments typed with generic D will be passed and should return a React node. */
export type PolyRenderType<D = ( ...params: any[] ) => ReactNode> = null | ReactNode | string | D;

interface Props {
	value: PolyRenderType,
	fallback?: ReactNode,
	fallbackOnString?: boolean
	funcParams?: Array<any>
}

const defaultProps: Props = {
	value:            null,
	fallback:         null,
	fallbackOnString: true,
	funcParams:       []
}

const PolyRenderer: FC<Props> = ( props ) => {
	
	const stringFunctionOrDefault = ( value ) => {
		
		if( !value ) return null;
		
		if( _.isString( value ) ) return props.fallbackOnString ? props.fallback : value;
		
		if( _.isFunction( value ) ) return value.apply( null, props.funcParams )
		
		return props.fallback;
	}
	
	return (
		
		<>{ stringFunctionOrDefault( props.value ) }</>
	);
};

PolyRenderer.defaultProps = defaultProps;

export { PolyRenderer }
